type DeeperdiveProps = {
  /** The URL path of the page. */
  urlPath: string;
  /** The counter of the Deeperdive component. */
  counter?: number;
};

/**
 * The Deeperdive component.
 * @figma https://www.figma.com/design/9RrH1KYIUOZk6rvgzlBBKX/WEB-BAU-2026?node-id=0-1&p=f&m=dev
 * */
const Deeperdive = ({
  urlPath,
  counter,
}: DeeperdiveProps): React.ReactElement => {
  const _counter = typeof counter === "number" ? `-${counter}` : "";

  return (
    <div
      data-testid="deeper-dive-component"
      id={`deeper-dive-container${_counter}`}
      className="track-impression deeper-dive-container"
      style={{ display: "none" }}
      aria-hidden="true"
      data-url={urlPath}
      data-section-name="deeperdive"
    ></div>
  );
};

export default Deeperdive;
